import React, { Component } from 'react';
import EmailTagItem from './EmailChipItem';

import styles from './email-tag.scss';

class EmailChipItemGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
        this.handleDelete = this.handleClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({ expanded: true });
    }

    render() {
        const { expanded } = this.state;
        const { emails, handleDelete, valid } = this.props;
        const count = emails.length;
        const classNames = `${styles.tagItem} ${valid ? '' : 'error'}`;
        return (
            !expanded
                ? <div className={classNames} onClick={this.handleClick}>{count} others...</div>
                : emails.map(email => (<EmailTagItem email={email} valid={valid} handleDelete={handleDelete} />))
        );
    }
}

export default EmailChipItemGroup;
